import { Route } from 'react-router';
import { Page } from '@roc/feature-app-core';
import { MyReferrals } from '../components/myReferrals';
import { BorrowerReferrals } from '../components/borrowerReferrals';

export const getReferralsRoutesConfig = (
  basePath: string,
  baseUrl: string
) => {
  return {
    myReferrals: {
      path: `${basePath}/my-referrals`,
      url: `${baseUrl}/my-referrals`,
      documentTitle: 'My Referrals',
    }
  };
};

export const geReferralsRoutes = (basePath: string, baseUrl: string) => {
  const config = getReferralsRoutesConfig(basePath, baseUrl);
  return {
    myReferrals: (
      <Route exact path={config.myReferrals.path}>
        <Page routeDefinition={config.myReferrals}>{<MyReferrals />}</Page>
      </Route>
    ),
  };
};

export const getBorrowerReferralsRoutesConfig = (
  basePath: string,
  baseUrl: string
) => {
  return {
    borrowerReferrals: {
      path: `${basePath}/borrower-referrals`,
      url: `${baseUrl}/borrower-referrals`,
      documentTitle: 'Borrower Referrals',
    }
  };
};

export const getBorrowerReferralsRoutes = (basePath: string, baseUrl: string) => {
  const config = getBorrowerReferralsRoutesConfig(basePath, baseUrl)
  return {
    borrowerReferrals: (
      <Route exact path={config.borrowerReferrals.path}>
        <Page routeDefinition={config.borrowerReferrals}>{<BorrowerReferrals />}</Page>
      </Route>
    ),
  };
};